import React from "react";
import { Stack, TextField } from "@mui/material";
import { OperandBuilder } from "../OperandBuilder";
import type { RuleComponentProps } from "./types";

export const RuleEndsWith: React.FC<RuleComponentProps> = ({
    value,
    onChange,
    evaluationDomain,
    declaredDerivedAttributeNames = [],
}) => {
    const ew = value?.endsWith;
    const left = ew?.left ?? { value: "" };
    const postfix = ew?.postfix ?? "";

    const updateLeft = (op: import("../../../../../../types/resolver").OperandDto | null) => {
        onChange({ endsWith: { ...ew, left: op ?? { value: "" }, postfix } });
    };

    const updatePostfix = (str: string) => {
        onChange({ endsWith: { ...ew, left, postfix: str } });
    };

    return (
        <Stack spacing={1}>
            <OperandBuilder
                label="Left"
                side="left"
                value={left}
                onChange={updateLeft}
                evaluationDomain={evaluationDomain}
                declaredDerivedAttributeNames={declaredDerivedAttributeNames}
                leftOperandTypes="keyOnly"
            />
            <TextField
                size="small"
                label="Postfix"
                value={postfix}
                onChange={(e) => updatePostfix(e.target.value)}
            />
        </Stack>
    );
};
